import settings from '../../settings.js';

import { setAlert } from '../alert/alert.actions';

export const fetchStart = () => ({
    type: "FETCH_START"
});
export const fetchSuccess = () => ({
    type: "FETCH_SUCCESS"
});
export const fetchFailure = errorMessage => ({
    type: "FETCH_FAILURE",
    payload: errorMessage
});

const getBanners = () => async (dispatch, getState) => {

    //dispatch(fetchStart());

    const state = getState();
    try {
        const response = await fetch(`${settings.connectionString}/api/banner/private`, {
            headers: {
                'Authorization': 'Bearer '+state.userReducer.currentUser.token
            },
            method: 'GET'
        });
        if (response.status >= 400 && response.status < 500) {
            throw "Error" + response.status;
        }
        if (response.status >= 500 && response.status < 600) {
        }
        const res = await response.json();
        console.log("set alert");
        /* dispatch(setAlert({ msg: "hola" })); */
        dispatch({
            type: 'GET_BANNERS',
            payload: res
        });

    } catch (error) {
        dispatch(fetchFailure(error.message));
    }
};

const getBannersFront = () => async dispatch => {

    //dispatch(fetchStart());

    try {
        const response = await fetch(`${settings.connectionString}/api/banner/public`, {
            method: 'GET'
        });
        if (response.status >= 400 && response.status < 500) {
            throw "Error" + response.status;
        }
        if (response.status >= 500 && response.status < 600) {
        }
        const res = await response.json();
        console.log("set alert");
        /* dispatch(setAlert({ msg: "hola" })); */
        dispatch({
            type: 'GET_BANNERS',
            payload: res
        });

    } catch (error) {
        dispatch(fetchFailure(error.message));
    }
};
const getBanner = (id) => async (dispatch, getState) => {
    dispatch(fetchStart());
    try {
        const response = await fetch(`${settings.connectionString}/api/banner/${id}`, {
            method: 'GET'
        });
        if (response.status >= 400 && response.status < 500) {
            throw "Error" + response.status;
        }
        if (response.status >= 500 && response.status < 600) {
        }
        const res = await response.json();
        console.log("getBanner response");
        console.log(res);
        res.dateFrom = new Date(res.dateFrom);
        res.dateTo = new Date(res.dateTo);
        dispatch({
            type: 'GET_BANNER',
            payload: res
        });
    } catch (error) {
        dispatch(fetchFailure(error.message));
    }
}

const addBanner = (body) => async (dispatch, getState) => {
    const state = getState();
    dispatch(fetchStart());
    console.log("addBanner");
    try {
        console.log(body);
        const response = await fetch(`${settings.connectionString}/api/banner`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+state.userReducer.currentUser.token
            },
            method: 'POST',
            body: JSON.stringify(body)
        });
        console.log(response);
        const res = await response.json();
        dispatch(fetchSuccess());
        dispatch(getBanners());
        if (res) {
            dispatch(setAlert({ msg: "Banner creado" }));
        }
        return true;
    } catch (error) {
        dispatch(fetchFailure(error.message));
        dispatch(setAlert({ msg: "No se pudo crear el banner" }));
    }
    return false;
}

const updateBanner = (body) => async (dispatch, getState) => {
    const state = getState();
    dispatch(fetchStart());
    console.log("updateBanner");
    try {
        console.log(body);
        const response = await fetch(`${settings.connectionString}/api/banner`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+state.userReducer.currentUser.token
            },
            method: 'PUT',
            body: JSON.stringify(body)
        });
        if (response.status >= 400 && response.status < 500) {
            throw "Error" + response.status;
        }
        if (response.status >= 500 && response.status < 600) {
        }
        console.log(response);
        const res = await response.json();
        dispatch(fetchSuccess());
        if (res) {
            dispatch(setAlert({ msg: "Banner actualizado" }));
        }
        return true;
    } catch (error) {
        dispatch(fetchFailure(error.message));
        dispatch(setAlert({ msg: "No se pudo actualizar el banner" }));
    }
    return false;
}

const deleteBanner = (id) => async (dispatch, getState) => {
    const state = getState();
    dispatch(fetchStart());
    console.log("deleteBanner");

    try {
        const response = await fetch(`${settings.connectionString}/api/banner/${id}`, {
            headers: {
                'Authorization': 'Bearer '+state.userReducer.currentUser.token
            },
            method: 'DELETE'
        });
        if (response.status >= 400 && response.status < 500) {
            throw "Error" + response.status;
        }
        if (response.status >= 500 && response.status < 600) {
        }
        console.log(response);
        const res = await response.json();

        if (res) {
            dispatch(setAlert({ msg: "Banner eliminado" }));
        }

        return true;

    } catch (error) {
        dispatch(fetchFailure(error.message));
        dispatch(setAlert({ msg: "Error al eliminar" }));
    }
    return false;
}

export default {
    getBanners,
    getBannersFront,
    addBanner,
    getBanner,
    updateBanner,
    deleteBanner
}